<script lang="ts">
  let props = $props()
  let { responses = [], scores = [] }: { responses: any; scores: any } = props

  let selectedTab = $state(1)

  const valuesResponseCount =
    responses["value1"].length +
    responses["value2"].length +
    responses["value3"].length +
    responses["value4"].length +
    responses["value5"].length

  const goalsResponseCount =
    responses["goal1"].length +
    responses["goal2"].length +
    responses["goal3"].length
</script>

<div>
  <div class="sm:hidden">
    <label for="tabs" class="sr-only">Select a tab</label>
    <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
    <select
      id="tabs"
      name="tabs"
      class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
    >
      <option selected>Brand Purpose</option>
      <option>Values</option>
      <option>Vision</option>
      <option>Goals</option>
    </select>
  </div>
  <div class="hidden sm:block">
    <nav
      class="isolate flex divide-x divide-gray-200 rounded-lg shadow"
      aria-label="Tabs"
    >
      <button
        onclick={() => (selectedTab = 1)}
        class="{selectedTab == 1
          ? 'text-gray-900'
          : 'text-gray-500 hover:text-gray-700'} rounded-lt-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
        aria-current="page"
      >
        <span>Brand Purpose</span>
        <span
          aria-hidden="true"
          class="{selectedTab == 1
            ? 'bg-amber-500'
            : 'bg-transparent'} absolute inset-x-0 bottom-0 h-0.5"
        ></span>
      </button>
      <button
        onclick={() => (selectedTab = 2)}
        class="{selectedTab == 2
          ? 'text-gray-900'
          : 'text-gray-500 hover:text-gray-700'} group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
      >
        <span>Values</span>
        <span
          aria-hidden="true"
          class="{selectedTab == 2
            ? 'bg-amber-500'
            : 'bg-transparent'} absolute inset-x-0 bottom-0 h-0.5"
        ></span>
      </button>
      <button
        onclick={() => (selectedTab = 3)}
        class="{selectedTab == 3
          ? 'text-gray-900'
          : 'text-gray-500 hover:text-gray-700'} group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
      >
        <span>Blue Sky Vision</span>
        <span
          aria-hidden="true"
          class="{selectedTab == 3
            ? 'bg-amber-500'
            : 'bg-transparent'} absolute inset-x-0 bottom-0 h-0.5"
        ></span>
      </button>
      <button
        onclick={() => (selectedTab = 4)}
        class="{selectedTab == 4
          ? 'text-gray-900'
          : 'text-gray-500 hover:text-gray-700'} rounded-rt-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
      >
        <span>Goals</span>
        <span
          aria-hidden="true"
          class="{selectedTab == 4
            ? 'bg-amber-500'
            : 'bg-transparent'} absolute inset-x-0 bottom-0 h-0.5"
        ></span>
      </button>
    </nav>
  </div>
</div>
<div class="bg-white shadow rounded-b-lg p-6">
  {#if selectedTab == 1}
    <p class="text-2xl text-grey-800 text-center">
      What is the company's Brand Purpose?
    </p>

    <div class="grid grid-cols-2 mt-6">
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          Total Number of Responses: {responses[`q2`].length} Responses
        </p>
      </div>
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          LWP Alignment Score: <span class="text-lg font-bold">
            {scores[2]}%
          </span>
        </p>
      </div>
      <div class="mt-4 col-span-2">
        <div
          class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3"
        >
          {#each responses[`q2`].sort() as response, i}
            <div class="border border-gray-200">
              <div
                class="text-center py-1 px-2 bg-gray-50 border-b border-gray-100"
              >
                Response #{i + 1}
              </div>
              <div class="text-center py-1 px-2">
                {#if response == "undefined" || response == "" || response == "null"}
                  <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                {:else}
                  <span class="p-2">{response}</span>
                {/if}
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  {:else if selectedTab == 2}
    <p class="text-xl text-grey-600 text-center">
      What are the top five Values of the company from most to least important?
    </p>

    <div class="grid grid-cols-2 mt-6">
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          Total Number of Responses: {valuesResponseCount}
        </p>
      </div>
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          LWP Alignment Score: <span class="text-lg font-bold">
            {scores[4]}%
          </span>
        </p>
      </div>
      <div class="mt-4 col-span-2">
        {#each [1, 2, 3, 4, 5] as value}
          <div
            class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3 items-center"
          >
            <p class="text-lg font-bold px-4">Value #{value}</p>
            {#each responses[`value${value}`].sort() as response, i}
              <div class="border border-gray-200">
                <div
                  class="text-center py-1 px-2 bg-gray-50 border-b border-gray-100"
                >
                  Response #{i + 1}
                </div>
                <div class="text-center py-1 px-2">
                  {#if response == "undefined" || response == "" || response == "null"}
                    <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                  {:else}
                    <span class="p-2">{response}</span>
                  {/if}
                </div>
              </div>
            {/each}
          </div>
        {/each}
      </div>
    </div>
  {:else if selectedTab == 3}
    <div class="p-6 border border-amber-50 shadow rounded">
      <p class="text-xl text-grey-600 mr-2">
        What is the company's Blue Sky Vision?
      </p>
    </div>

    <div class="grid grid-cols-2 mt-6">
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          Total Number of Responses: {responses[`q3`].length}
        </p>
      </div>
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          LWP Alignment Score: <span class="text-lg font-bold">
            {scores[3]}%
          </span>
        </p>
      </div>
      <div class="mt-4 col-span-2">
        <div
          class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3"
        >
          {#each responses[`q3`].sort() as response, i}
            <div class="border border-gray-200">
              <div
                class="text-center py-1 px-2 bg-gray-50 border-b border-gray-100"
              >
                Response #{i + 1}
              </div>
              <div class="text-center py-1 px-2">
                {#if response == "undefined" || response == "" || response == "null"}
                  <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                {:else}
                  <span class="p-2">{response}</span>
                {/if}
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  {:else if selectedTab == 4}
    <div class="p-6 border border-amber-50 shadow rounded">
      <p class="text-xl text-grey-600 mr-2">
        What are your team's top 3 Annual Goals this year?
      </p>
    </div>

    <div class="grid grid-cols-2 mt-6">
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          Total Number of Responses: {goalsResponseCount}
        </p>
      </div>
      <div class="border-b border-grey-200 py-2">
        <p class="text-left text-sm font-semibold text-gray-900">
          LWP Alignment Score: <span class="text-lg font-bold">
            {scores[5]}%
          </span>
        </p>
      </div>
      <div class="mt-4 col-span-2">
        {#each [1, 2, 3] as value}
          <div
            class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 col-span-4 flex gap-3 items-center"
          >
            <p class="text-lg font-bold px-4">Goal #{value}</p>
            {#each responses[`goal${value}`].sort() as response, i}
              <div class="border border-gray-200">
                <div
                  class="text-center py-1 px-2 bg-gray-50 border-b border-gray-100"
                >
                  Response #{i + 1}
                </div>
                <div class="text-center py-1 px-2">
                  {#if response == "undefined" || response == "" || response == "null"}
                    <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                  {:else}
                    <span class="p-2">{response}</span>
                  {/if}
                </div>
              </div>
            {/each}
          </div>
        {/each}
      </div>
    </div>
  {/if}
</div>
